import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from '../../utils/icons';
import type { Breadcrumb } from '../../types/drive';

interface DriveBreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
}

const DriveBreadcrumbs: React.FC<DriveBreadcrumbsProps> = ({ breadcrumbs }) => {
  const ChevronRightIcon = ChevronRight as React.ComponentType<{ className?: string; size?: number }>;

  return (
    <nav className="flex items-center gap-1 text-sm text-slate-500 dark:text-slate-400 flex-wrap">
      <Link
        to="/dashboard/legal-forms"
        className="hover:text-primary dark:hover:text-primary-dark transition-colors"
      >
        Forms and Precedents
      </Link>

      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={crumb.id}>
            <ChevronRightIcon size={14} className="text-slate-400 flex-shrink-0" />
            {isLast ? (
              <span className="font-semibold text-slate-700 dark:text-slate-200 truncate max-w-[200px]">
                {crumb.name}
              </span>
            ) : (
              <Link
                to={`/dashboard/legal-forms/folder/${crumb.id}`}
                className="hover:text-primary dark:hover:text-primary-dark transition-colors truncate max-w-[200px]"
              >
                {crumb.name}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default DriveBreadcrumbs;
